module.exports = __webpack_public_path__ + "img/horse-portrait-painting-4.5f12f25c.png";